<template>
  <div class="table-empty">
    <uc-empty empty-type="data" description="" class="resource-table-empty">
      <template slot="content">
        <div v-if="!recycleType">
          <span style="line-height: 28px;color:#606366;" v-if="queryParamsKey != ''"><div>没有搜索到相关结果</div><div>试试其他关键词或点击“回车”键重新发起搜索</div></span>
          <span v-else>你还没有上传文件哦，点击 <span class="resource-table-upload-link" @click="uploadFiles(false)">上传</span> 按钮~</span>
        </div>
        <div v-else class="tips minor-font">
          <div>你的回收站为空哦~</div>
          <div class="recycle-time">您的文件将在{{ recycleTime }}天后自动清除</div>
        </div>
        <div class="resource-table-empty-bottom minor-font" v-if="recycleType || queryParamsKey == ''">
          <div>您还可以下载我的资源客户端</div>
          <div>
            <el-button @click="downloadNav('pc')">优领课智慧教学工具【Win版】</el-button>
            <el-popover placement="top" width="200" popper-class="download-box-popover" trigger="hover">
              <div class="download-box">
                <div class="box">
                  <div class="image-box">
                    <vue-qr style="left:60px" :text="getQrUrl" :size="60" :margin="0"></vue-qr>
                  </div>
                  <div class="box-title"><span class="main">优领课授课助手</span> <span class="min">一款帮助老师快速同步、展示和控制大屏课件的手机应用。</span> </div>
                  <div class="box-bot" style="font-size:12px;line-height:35px"> 请扫码安装 </div>
                </div>
              </div>
              <el-button class="pc_download_link" slot="reference">优领课授课助手</el-button>
            </el-popover>
            <!--                  <el-button @click="downloadNav('res')">优领课同步助手【Win版】</el-button>-->
          </div>
        </div>
      </template>
    </uc-empty>
  </div>
</template>

<script>
import vueQr from "vue-qr";
export default {
  name: "ResourceEmpty",
  components: {
    vueQr
  },
  props: {
    // 回收站标识
    recycleType: {
      type: Boolean,
      default: false
    },
    // 回收站默认删除时间
    recycleTime: {
      type: Number,
      default: 30
    },
    queryParamsKey: {
      type: String,
      default: ''
    },
  },
  computed:{
   getQrUrl() {
      try {
        let info =  this.$store.state.navInfo;
        if (info && info.qrUrl) {
          return info.qrUrl;
        }
      } catch (e) {
        console.log(e)
      }
      return '';
   }
  },

  methods:{
    uploadFiles(flag) {
      this.$emit('uploadFiles', flag)
    },
    downloadNav(type) {
      if (type == 'res') {
        window.open(window.navUserInfo.resdownUrl, "_self")
      } else if (type == 'pc') {
        window.open(window.navUserInfo.pcdownUrl, "_self")
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.table-empty {
  text-align: center;
  font-size: 14px;

  .tips {
    margin-top: 25px;
    font-weight: bold;

    .recycle-time {
      margin-top: 24px;
      font-weight: 400;
    }
  }
}

.download-box {
  display: flex;
  width: 100%;
  height: 180px;
  font-size: 12px !important;
  text-align: center;
  .box {

    display: inline-block;
    text-align: center;
    vertical-align: top;
    .box-title {
      height: auto;
      margin-bottom: 5px;
      span {
        display: block;
        word-wrap: break-word;
        line-height: 16px;
        text-overflow: ellipsis;
        white-space: normal;
        font-size: 12px;
      }
      .main {
        color: #303233;
        margin-bottom: 2px;
      }
      .min {
        color: #909599;
        padding: 0 15px;
      }
    }
  }
  .image-box {
    text-align: center;
    padding-top: 10px;
    position: relative;
    height: 75px;
  }
  .logo {
    width: 60px;
    height: 60px;
  }
}
</style>
